import moment from "moment";
import "moment/locale/es";
import {
  Button, Dialog,
  DialogTitle,
  DialogContent
} from "@material-ui/core";
import React, { memo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { MENU_CONTRATACIONES } from "../../../utils/constants";
import { fetchModulosPorEfectorFacturacion, guardarModuloPorEfectorFacturacion } from "../../../actions/contrataciones/contratacionesModulos";
import { ModulosTable } from "./ModulosTable";
import { ModulosContratacionesForm } from "./ModulosContratacionesForm";
import { fetchModulos } from "../../../actions/contrataciones/configuraciones/abmModulos";

export const ModulosContrataciones = memo((props) => {
  const dispatch = useDispatch();
  moment.locale("es");
  const [openModal, setOpenModal] = React.useState(false);

  const disabled = props.menu === MENU_CONTRATACIONES.CONSULTA;

  const { items = [] } = useSelector((state) => state.modulosContratos);
  const idEfectorFact = props.idEfectorFacturacion;

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleOpenModal = () => {
    setOpenModal(true);
  };

  useEffect(() => {
    if (items?.length === 0) {
      dispatch(fetchModulos());
    }
    dispatch(fetchModulosPorEfectorFacturacion(idEfectorFact))
  }, [dispatch]);


  return (
    <>
      {
      !disabled && (

        <Button
          variant="contained"
          color="primary"
          size="small"
          onClick={handleOpenModal}
          style={{ float: "right" }}
        >
          + Agregar Modulo
        </Button>
      )
      }
      <ModulosTable
        disabled={disabled}
      />
      {
        openModal && (
          <Dialog
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="alert-dialog-slide-title"
            aria-describedby="alert-dialog-slide-description"
            maxWidth="lg"
            fullWidth
          >
            <DialogTitle id="alert-dialog-slide-title">
              {"Agregar Modulo"}
            </DialogTitle>
            <DialogContent>
              <ModulosContratacionesForm formData={null} handleSubmit={(data) => {
                dispatch(guardarModuloPorEfectorFacturacion(data, () => handleCloseModal()))
              }} handleCloseModal={handleCloseModal} />
            </DialogContent>
          </Dialog>
        )
      }

    </>
  );
});
